import React from 'react'
import AuthService from '../../services/auth'

const SignoutPage = () => {
  const currentLoggedInUser = new AuthService()

  React.useEffect(() => {
    currentLoggedInUser._msalApp.clearCache()
  }, [currentLoggedInUser._msalApp])

  return (
    <>
      <p className="signout-page-content" data-test="signout-page-content">
     Please wait while we sign you out of all applications.
      </p>
    </>
  )
}

export default SignoutPage